var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "visitor-activities" }, [
    !!_vm.activitiesClone.length
      ? _c(
          "div",
          { staticClass: "activities" },
          [
            _c(
              "vue-scroll",
              { staticClass: "scroll" },
              _vm._l(_vm.activitiesClone, function (activity) {
                return _c(
                  "div",
                  {
                    staticClass: "activity-item",
                    class: _vm.opened == activity.id && "show-details",
                    on: {
                      click: function ($event) {
                        return _vm.showDetails(activity.id)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "activity-info" }, [
                      _c("div", { staticClass: "activity-type" }, [
                        _c("div", { staticClass: "material-icons" }, [
                          _vm._v(_vm._s(_vm.detailOption[activity.type].icon)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "activity-about" }, [
                        _c("div", { staticClass: "activity-about-title" }, [
                          _vm._v(_vm._s(_vm.detailOption[activity.type].text)),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "activity-about-date" }, [
                          _vm._v(
                            _vm._s(_vm.$moment(activity.createdAt).fromNow())
                          ),
                        ]),
                      ]),
                    ]),
                    _vm._v(" "),
                    [
                      // hangi actionlarda detail varsa
                      "visitor-profile-updated",
                      "blocked",
                      "unblocked",
                      "create-ticket",
                      "visitor-tag-added",
                      "visitor-tag-removed",
                      "note-created",
                      "note-updated",
                      "page-changed",
                      "chat-opened",
                    ].includes(activity.type)
                      ? _c(
                          "div",
                          { staticClass: "activity-details" },
                          [
                            activity.actorUser
                              ? [
                                  _c("div", { staticClass: "activity-add" }, [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("person")]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(activity.actorUser.name) +
                                        "\n                        "
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            [
                              "visitor-tag-added",
                              "visitor-tag-removed",
                            ].includes(activity.type)
                              ? [
                                  !_vm.isArray(activity.payload)
                                    ? _c(
                                        "div",
                                        { staticClass: "activity-add" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "material-icons" },
                                            [_vm._v("add")]
                                          ),
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(activity.payload.tagName) +
                                              "\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._l(activity.payload, function (tag) {
                                        return _c(
                                          "div",
                                          { staticClass: "activity-add" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "material-icons" },
                                              [_vm._v("add")]
                                            ),
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(tag.tagName) +
                                                "\n                        "
                                            ),
                                          ]
                                        )
                                      }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            activity.type == "visitor-profile-updated"
                              ? [
                                  _vm._l(
                                    Object.keys(activity.payload),
                                    function (key) {
                                      return [
                                        _vm.visitorAttributes[key]
                                          ? [
                                              _c(
                                                "div",
                                                { staticClass: "activity-add" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("add")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.visitorAttributes[
                                                          key
                                                        ].label
                                                      ) + " "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    ": " +
                                                      _vm._s(
                                                        activity.payload[key]
                                                          .newVal
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "activity-add" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("remove")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.visitorAttributes[
                                                          key
                                                        ].label
                                                      ) + " "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    ":\n                                    " +
                                                      _vm._s(
                                                        activity.payload[key]
                                                          .oldVal || "N/A"
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          : [
                                              _c(
                                                "div",
                                                { staticClass: "activity-add" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("add")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$_.startCase(key)
                                                      ) + " "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    ": " +
                                                      _vm._s(
                                                        activity.payload[key]
                                                          .newVal
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "activity-add" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "material-icons",
                                                    },
                                                    [_vm._v("remove")]
                                                  ),
                                                  _vm._v(" "),
                                                  _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$_.startCase(key)
                                                      ) + " "
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    ": " +
                                                      _vm._s(
                                                        activity.payload[key]
                                                          .oldVal || "N/A"
                                                      ) +
                                                      "\n                                "
                                                  ),
                                                ]
                                              ),
                                            ],
                                      ]
                                    }
                                  ),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            activity.type == "note-created"
                              ? [
                                  _c("div", { staticClass: "activity-add" }, [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("add")]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(activity.payload.note) +
                                        "\n                        "
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            activity.type == "note-updated"
                              ? [
                                  _c("div", { staticClass: "activity-add" }, [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("add")]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(activity.payload.newNote) +
                                        "\n                        "
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "activity-add" }, [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("remove")]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(activity.payload.oldNote) +
                                        "\n                        "
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            activity.type == "chat-opened" &&
                            activity.payload.visitorDetail
                              ? [
                                  activity.payload.visitorDetail.fullname
                                    ? _c(
                                        "div",
                                        { staticClass: "activity-add" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "material-icons" },
                                            [_vm._v("badge")]
                                          ),
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                activity.payload.visitorDetail
                                                  .fullname.oldVal
                                              ) +
                                              " ->\n                            " +
                                              _vm._s(
                                                activity.payload.visitorDetail
                                                  .fullname.newVal
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  activity.payload.visitorDetail.email
                                    ? _c(
                                        "div",
                                        { staticClass: "activity-add" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "material-icons" },
                                            [_vm._v("mail")]
                                          ),
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                activity.payload.visitorDetail
                                                  .email.oldVal
                                              ) +
                                              " ->\n                            " +
                                              _vm._s(
                                                activity.payload.visitorDetail
                                                  .email.newVal
                                              ) +
                                              "\n                        "
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            activity.type == "create-ticket"
                              ? [
                                  _c("div", { staticClass: "activity-add" }, [
                                    _c(
                                      "div",
                                      { staticClass: "material-icons" },
                                      [_vm._v("sticky_note_2")]
                                    ),
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          activity.payload.osrPayload.message
                                        ) +
                                        "\n                        "
                                    ),
                                  ]),
                                ]
                              : _vm._e(),
                          ],
                          2
                        )
                      : _vm._e(),
                  ]
                )
              }),
              0
            ),
          ],
          1
        )
      : _c("div", { staticClass: "data-box" }, [_vm._m(0)]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "last-session-info" }, [
      _c(
        "div",
        { staticClass: "material-icons", staticStyle: { "font-size": "20px" } },
        [_vm._v("block")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "last-session-data",
          staticStyle: { "margin-top": "5px" },
        },
        [_vm._v("No user data were found")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }